import PropTypes from "prop-types";
import Typography from "@material-ui/core/Typography";
import Button from "@material-ui/core/Button";
import { TDialog, TDialogTitle, TDialogContent, TDialogActions } from "../../Common/TDialog";

export const ForgotPasswordSentDialog = (props) => {
    return (
        <TDialog open={props.open}>
            <TDialogTitle>Forgot my password</TDialogTitle>

            <TDialogContent>
                <Typography style={{ color: "#0000008a", marginBottom: "20px" }}>
                    An email was sent to <span style={{ fontWeight: "bold" }}>{props.email}</span> with instructions on
                    how to change your password.
                </Typography>

                <Typography style={{ color: "#0000008a" }}>
                    If you do not see the email, please check your spam folder.
                </Typography>
            </TDialogContent>

            <TDialogActions>
                <Button color="secondary" disabled={props.saving} onClick={props.onBack}>
                    Back
                </Button>
            </TDialogActions>
        </TDialog>
    );
};

ForgotPasswordSentDialog.propTypes = {
    open: PropTypes.bool.isRequired,
    email: PropTypes.string,
    saving: PropTypes.bool,
    onBack: PropTypes.func,
};

export default ForgotPasswordSentDialog;
